<!-- section template -->
<template>
  <el-dialog :visible.sync="dialog2MixinVisible" :custom-class="`${$style.dialogAlerrtSuccessAdd} isStyleLogin text-center`" width="738px" append-to-body @closed="$Dialog2MixinOnDestroy">
    <div class="dialogAlerrtSuccessAdd__content"> 尚未完成預約，<br class="title-br" />確定要離開預約流程？ </div>
    <div class="warning">尚未完成預約</div>
    <div class="sub-content">點擊『繼續預約』完成完整流程後預約才會成立</div>
    <hr />
    <BaseButton class="isStylePrimary isFull" :class="{ isRadius: $globalIsJtails }" @click="dialog2MixinVisible = false">繼續預約</BaseButton>
    <BaseButton class="isStyleDark isOutline3 isFull mt-4" :class="{ isRadius: $globalIsJtails }" @click="leave">下次再來</BaseButton>
  </el-dialog>
</template>

<script>
import dialog2Mixin from '../mixins/dialog2'

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      cartType: '',
      value: {}, // submitData
      cart: {}, // 購物車
      next: () => {},
    }
  },
  methods: {
    leave() {
      this.next()
      this.dialog2MixinVisible = false
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.dialogAlerrtSuccessAdd {
  :global {
    .warning {
      display: inline-block;
      color: #ec5151;
      background-color: #fef1f1;
      padding: 4px 8px;
      margin: 8px 0;
    }
    .sub-content {
      color: #726f65;
      font-size: 12px;
    }
    .dialogAlerrtSuccessAdd {
      &__content {
        font-size: 1.125rem;
        line-height: 2;
        color: $color-primary;
        text-align: center;
        font-weight: 500;
      }
    }
  }
}
@media (min-width: 768px) {
  .dialogAlerrtSuccessAdd {
    :global {
      .title-br {
        display: none;
      }
    }
  }
}
@media (min-width: 992px) {
  .dialogAlerrtSuccessAdd {
    :global {
      .sub-content {
        font-size: 14px;
      }
    }
  }
}
</style>
